import React from 'react';

import {
  avatarFrameRender,
  onCommonRender,
  borderStyleRenderer,
} from './render';

import './web-coin-shop-card.css';
import { useTranslations } from 'next-intl';
import { cn } from '@wwe-portal/ui/lib/lib';
import { Button } from '@wwe-portal/ui/components/button';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';
import { formatThousands } from '@wwe-portal/utils/format';
import { AlternativePurchaseTypes } from '@wwe-portal/web/services/payment/type';
import LoadAnimateButton from '../../load-animate-button';

function WebCoinShopCard({
  title,
  rarity,
  image,
  paymentLoading,
  name,
  price,
  id,
  unlocked,
  handlePurchaseClick,
  handlePurchaseEnergyClick,
  listType = '',
  newItem,
  index,
  quantity,
}: Readonly<{
  title: string;
  rarity: string;
  image: string;
  paymentLoading: boolean;
  name?: string;
  price: number;
  id?: number;
  unlocked: boolean;
  handlePurchaseClick?: (
    price: number,
    id: number | undefined,
    listType: AlternativePurchaseTypes,
    title: string
  ) => void;
  handlePurchaseEnergyClick?: (
    name: string,
    price: number,
    count?: number
  ) => void;
  listType?: string;
  newItem?: any;
  index: number;
  quantity?: number;
}>) {
  const t = useTranslations();

  return (
    <div
      className="w-full rounded"
      id={index === 0 && listType === 'energy' ? 'energy-pack-item-block' : ''}
      style={borderStyleRenderer(rarity)}
    >
      <div className="bg-back400 flex justify-center py-[15px]">
        <p
          className="text-text400 mb-0 w-[90%] truncate text-center"
          id={index === 0 && listType === 'energy' ? 'energy-pack-title' : ''}
        >
          {title}
        </p>
      </div>
      <div className="web-coin-shop-card-image bg-back200 w-full px-[30px] pb-[30px] pt-5">
        <div
          className={cn(
            `web-coin-shop-card-image-back relative mb-0 flex items-center justify-center`,
            {
              'mb-[30px]': listType === 'energy',
            }
          )}
        >
          <img src="/assets/images/cash-pack-item-shine.png" alt="shine" />
          <div
            className="web-coin-shop-card-image-back-shine-block"
            style={avatarFrameRender(true, rarity, true)}
          />
          <div
            className="web-coin-shop-card-image-back-shine-block-image"
            id={
              index === 0 && listType === 'frame'
                ? 'first-frame-item'
                : index === 0 && listType === 'avatar'
                  ? 'first-avatar-item'
                  : ''
            }
            style={
              listType === 'energy'
                ? {
                    backgroundImage: `url(${image})`,
                    backgroundSize: 'auto',
                  }
                : { backgroundImage: `url(${image})` }
            }
          />
        </div>
        {listType !== 'energy' ? (
          <div className="mb-5">{onCommonRender(rarity)}</div>
        ) : (
          <div className="mb-5">
            <p
              className="text-text400 mb-0 text-xs font-semibold"
              style={{ marginTop: 7 }}
              id={
                index === 0 && listType === 'energy' ? 'energy-pack-left' : ''
              }
            >
              {quantity || 1} {t('left')}
            </p>
          </div>
        )}
        <Button
          onClick={
            paymentLoading
              ? () => {}
              : listType === 'energy'
                ? () =>
                    handlePurchaseEnergyClick?.(
                      name ?? '',
                      price,
                      newItem.count
                    )
                : () =>
                    handlePurchaseClick?.(
                      price,
                      id,
                      listType as AlternativePurchaseTypes,
                      title
                    )
          }
          disabled={unlocked}
          variant="orange"
          className="web-coin-shop-card-image-button flex items-center"
          data-id={`webcoin_shop_${id || name}_button`}
          id={
            index === 0 && listType === 'frame'
              ? 'avatar-frame-claim-button'
              : index === 0 && listType === 'energy'
                ? 'energy-pack-buy-button'
                : index === 0 && listType === 'avatar'
                  ? 'avatar-claim-button'
                  : ''
          }
        >
          {paymentLoading ? (
            <div>
              <LoadAnimateButton />
            </div>
          ) : unlocked ? (
            <p className="mb-0 text-xs font-semibold">{t('purchased')}</p>
          ) : (
            <div className="flex items-center">
              <IcoMoonIcon
                iconName="web-coin-circle"
                className="mr-[1px] size-4"
              />
              <p className="mb-0 text-xs font-semibold">
                {formatThousands(price)}
              </p>
            </div>
          )}
        </Button>
      </div>
    </div>
  );
}

export default WebCoinShopCard;
